import React from 'react';
interface StatsCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  subtitle?: string;
  onClick?: () => void;
  iconBgColor?: string;
  iconColor?: string;
}
export function StatsCard({
  title,
  value,
  icon,
  subtitle,
  onClick,
  iconBgColor = 'bg-[#006A4E]/10',
  iconColor = 'text-[#006A4E]'
}: StatsCardProps) {
  return <div onClick={onClick} className={`bg-white rounded-xl shadow-sm border border-slate-100 p-6 flex items-start gap-4 ${onClick ? 'cursor-pointer hover:shadow-md hover:border-[#006A4E]/30 transition-all' : ''}`} data-id="element-139">
      <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0 ${iconBgColor} ${iconColor}`} data-id="element-140">
        {icon}
      </div>
      <div data-id="element-141">
        <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-142">{title}</p>
        <h4 className="text-2xl font-bold text-slate-800" data-id="element-143">{value}</h4>
        {subtitle && <p className="text-xs text-slate-400 mt-1" data-id="element-144">{subtitle}</p>}
      </div>
    </div>;
}